// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.footer {
    background-color: #f8f9fa;
    padding: 10px;
    border-top: 1px solid #e7e7e7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -50px;
    position: relative;
    z-index: 10;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: -5px;
  }
  
  .footer-content span {
    font-size: 14px;
    color: #333;
    margin-left: 8px;
  }
  
  .social-icons {
    display: flex;
    gap: 12px;
  }
  
  .icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #e9ecef;
    color: #373435;
    font-size: 16px;
    text-decoration: none;
    transition: background-color 0.3s ease, color 0.3s ease;
  }
  
  .icon:hover {
    background-color: #007bff;
    color: white;
  }
  
  .icon.facebook:hover {
    background-color: #3b5998;
  }
  
  .icon.twitter:hover {
    background-color: #000000;
  }

  .icon.instagram:hover {
    background: linear-gradient(to right, #FED075, #FA7E1E, #D62976, #962FBF, #4F5BD5);
  }
  
  .icon.linkedin:hover {
    background-color: #0077b5;
  }
  
  .icon.rss:hover {
    background-color: #f26522;
  }
  
  .icon.youtube:hover {
    background-color: #ff0000;
  }

/* Responsive layout */
@media (max-width: 450px) {
  .footer {
      margin-top: 0;
  }
}  `, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,uDAAuD;EACzD;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kFAAkF;EACpF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;AAEF,sBAAsB;AACtB;EACE;MACI,aAAa;EACjB;AACF","sourcesContent":["\r\n.footer {\r\n    background-color: #f8f9fa;\r\n    padding: 10px;\r\n    border-top: 1px solid #e7e7e7;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-top: -50px;\r\n    position: relative;\r\n    z-index: 10;\r\n}\r\n\r\n.footer-content {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    margin-top: -5px;\r\n  }\r\n  \r\n  .footer-content span {\r\n    font-size: 14px;\r\n    color: #333;\r\n    margin-left: 8px;\r\n  }\r\n  \r\n  .social-icons {\r\n    display: flex;\r\n    gap: 12px;\r\n  }\r\n  \r\n  .icon {\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    background-color: #e9ecef;\r\n    color: #373435;\r\n    font-size: 16px;\r\n    text-decoration: none;\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n  }\r\n  \r\n  .icon:hover {\r\n    background-color: #007bff;\r\n    color: white;\r\n  }\r\n  \r\n  .icon.facebook:hover {\r\n    background-color: #3b5998;\r\n  }\r\n  \r\n  .icon.twitter:hover {\r\n    background-color: #000000;\r\n  }\r\n\r\n  .icon.instagram:hover {\r\n    background: linear-gradient(to right, #FED075, #FA7E1E, #D62976, #962FBF, #4F5BD5);\r\n  }\r\n  \r\n  .icon.linkedin:hover {\r\n    background-color: #0077b5;\r\n  }\r\n  \r\n  .icon.rss:hover {\r\n    background-color: #f26522;\r\n  }\r\n  \r\n  .icon.youtube:hover {\r\n    background-color: #ff0000;\r\n  }\r\n\r\n/* Responsive layout */\r\n@media (max-width: 450px) {\r\n  .footer {\r\n      margin-top: 0;\r\n  }\r\n}  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
